import session from '../helpers/client-session';

export default {
    install(Vue, options) {
        var analyticsService = {
            pageView: (trackingEvent) => {
                var trackingData = {};
                trackingData.page_referrer = window.location.origin;
                trackingData.category = session.getCategory();

                if (trackingEvent) {
                    ltanalytics.page(trackingEvent, trackingData);
                }
                else {
                    ltanalytics.page(trackingData);
                }
            },
            trackCTA: (trackingData, trackingEvent) => {
                trackingData.category = session.getCategory();
                trackingData.cc_session_id = session.getCookie('csid_comparecards');
                trackingData.page_referrer = window.location.origin;
                ltanalytics.track(trackingEvent, trackingData);
            },
            getCategoryName: () => {
                return session.getCategory();
            },
        }

        Vue.prototype.$analyticsService = analyticsService;
    },
}